import { playVideo as requestVideoPlayback, pauseVideo } from './autoplayVideos.js';

export function teamCard(scope = document) {
    scope.querySelectorAll('[data-team-card]').forEach((card) => {
        if (card.dataset.teamCardInitialized) return;

        card.dataset.teamCardInitialized = 'true';
        const video = card.querySelector('.team-card__video');

        const playVideo = () => {
            if (!video) return;

            requestVideoPlayback(video);
        };

        const stopVideo = () => {
            if (!video) return;

            pauseVideo(video);
            video.currentTime = 0;
            card.classList.remove('is-video-playing');
        };

        video?.addEventListener('playing', () => {
            card.classList.add('is-video-playing');
        });

        const setExpanded = (expanded) => {
            card.classList.toggle('is-expanded', expanded);
            card.setAttribute('aria-expanded', String(expanded));
        };

        card.addEventListener('click', (event) => {
            if (event.target.closest('a')) return;
            setExpanded(!card.classList.contains('is-expanded'));
        });

        card.addEventListener('mouseenter', playVideo);
        card.addEventListener('mouseleave', stopVideo);
        card.addEventListener('focusin', playVideo);
        card.addEventListener('focusout', (event) => {
            if (!card.contains(event.relatedTarget)) stopVideo();
        });

        card.addEventListener('keydown', (event) => {
            if (event.target !== card) return;

            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setExpanded(!card.classList.contains('is-expanded'));
            }

            if (event.key === 'Escape') {
                setExpanded(false);
            }
        });
    });
}
